import { getCurrentCountry } from '@front/common/src/utils/country';
import { Country } from '@front/common/src/types/commons';

export type RoutePath =
  | 'feat'
  | 'root'
  | 'register'
  | 'pro_status'
  | 'additional_information'
  | 'appointment'
  | 'confirmation'
  | 'not_qualified';

const ROUTES: Record<Country, Record<RoutePath, string>> = {
  FR: {
    feat: '/feat',
    root: '/',
    register: '/inscription',
    pro_status: '/statut-professionnel',
    additional_information: '/informations',
    appointment: '/rendez-vous',
    confirmation: '/felicitations',
    not_qualified: '/partenariat_impossible',
  },
  GB: {
    feat: '/feat',
    root: '/',
    register: '/register',
    pro_status: '/professional-status',
    additional_information: '/information',
    appointment: '/appointment',
    confirmation: '/congratulations',
    not_qualified: '/impossible_partnership',
  },
};

export const route = (path: RoutePath) => ROUTES[getCurrentCountry()][path];
